/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupMembershipDtoPage } from '../../models/group-membership-dto-page';

export interface ListGroupMemberships$Params {
  projectId: string;
  roleIds?: Array<string>;
  groupIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'member' | '-member' | 'id' | '-id' | 'projectId' | '-projectId' | 'memberId' | '-memberId' | 'role' | '-role' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listGroupMemberships(http: HttpClient, rootUrl: string, params: ListGroupMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupMembershipDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listGroupMemberships.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('roleIds', params.roleIds, {});
    rb.query('groupIds', params.groupIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupMembershipDtoPage>;
    })
  );
}

listGroupMemberships.PATH = '/v0/memberships/groups';
